// src/index.ts
import { search, AnswerSession as OSSAnswerSession } from "@orama/orama";
function isOramaClient(client) {
  return client && typeof client === "object" && "api_key" in client && "endpoint" in client;
}
var Switch = class {
  invalidClientError = "Invalid client. Expected either an OramaClient or an Orama OSS database.";
  client;
  clientType;
  isCloud = false;
  isOSS = false;
  constructor(client) {
    this.client = client;
    if (isOramaClient(client)) {
      this.clientType = "cloud";
      this.isCloud = true;
    } else if (typeof client === "object" && "id" in client && "tokenizer" in client) {
      this.clientType = "oss";
      this.isOSS = true;
    } else {
      throw new Error(this.invalidClientError);
    }
  }
  async search(params, config) {
    if (this.isCloud) {
      return this.client.search(params, config);
    } else {
      return search(this.client, params);
    }
  }
  createAnswerSession(params) {
    if (this.isCloud) {
      const p = params;
      return this.client.createAnswerSession(p);
    }
    if (this.isOSS) {
      const p = params;
      return new OSSAnswerSession(this.client, {
        conversationID: p.conversationID,
        initialMessages: p.initialMessages,
        events: p.events,
        userContext: p.userContext,
        systemPrompt: p.systemPrompt
      });
    }
    throw new Error(this.invalidClientError);
  }
};
export {
  Switch
};
//# sourceMappingURL=index.js.map